<!-- Main input with calendar icon -->
<div>
  <div class="input-group">
    <input type="text" class="form-control floating-input" [formControl]="dateControl" placeholder="Date Selection"
      readonly>
    <div class="input-group-append">
      <!-- Button to open the calendar modal -->
      <button class="btn btn-primary mdi mdi-calendar-month-outline" [disabled]="disable"
        (click)="openModal()"></button>
    </div>
  </div>
</div>


<!-- Modal template for calendar selection -->
<ng-template #calendarTemplate>
  <div class="modal-header">
    <!-- Title of modal -->
    <h5 class="modal-title font-weight-bold">{{ 'parameter.SelectTimePeriod' | translate }}</h5>

    <!-- Close button for modal -->
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- Dropdown for selecting predefined date range or 'Custom' -->
    <ng-select [items]="dateFilterList" bindLabel="displayName" bindValue="name" placeholder="Date Selection"
      [clearable]="false" [(ngModel)]="selectedType">
    </ng-select>

    <!-- Custom date range inputs -->
    <div *ngIf="selectedType === 'Custom'" class="input-group mt-3">
      <!-- FROM date input -->
      <input class="form-control" placeholder="From" ngbDatepicker #fromDp="ngbDatepicker" [(ngModel)]="fromDate"
        (dateSelect)="onDateSelect()" [maxDate]="today" readonly>
      <div class="input-group-append">
        <button class="btn btn-outline-primary mdi mdi-calendar-blank-outline" (click)="fromDp.toggle()"
          type="button"></button>
      </div>

      <!-- TO date input -->
      <input class="form-control ml-3" placeholder="To" ngbDatepicker #toDp="ngbDatepicker" [(ngModel)]="toDate"
        (dateSelect)="onDateSelect()" [maxDate]="today" [minDate]="fromDate" [disabled]="!fromDate" readonly>
      <div class="input-group-append">
        <button class="btn btn-outline-primary mdi mdi-calendar-blank-outline" (click)="toDp.toggle()"
          type="button"></button>
      </div>
    </div>
  </div>

  <!-- Modal footer with Submit button -->
  <div class="modal-footer">
    <button class="btn btn-primary" [disabled]="!selectedType || (selectedType === 'Custom' && (!fromDate || !toDate))
  " (click)="submit()">{{ 'Ok' | translate }}</button>
  </div>
</ng-template>